export const userKeyFactory = {
  all: [{ scope: 'user' }] as const,
  me: () => [{ ...userKeyFactory.all[0], entity: 'me' }] as const,
  emailSubscription: () =>
    [{ ...userKeyFactory.all[0], entity: 'emailSubscription' }] as const,
}
